import { Component } from '@angular/core';

/**
 * NoContentComponent - if route url was wrong, app shows 404 page
 */
@Component({
    selector: 'no-content',
    template: `
    <div>
      <h2 style="margin-top: 100px; text-align: center;">404: page is missing</h2>
    </div>
  `
})
export class NoContentComponent {

}



// WEBPACK FOOTER //
// ./src/app/no-content/no-content.component.ts